import React from 'react';
import GenericTable from 'screens/components/advanced/GenericTable';
import LOOKUP from 'constants/lookup';
import Pagination from 'screens/components/basic/Pagination';
import { mapPoints } from 'utils/mappers';
import CardSimple from 'screens/components/basic/CardSimple';

const patientTabPoints = ({ points, pagination, changePage}) => {
    const compName = 'points';
    return (
        <div className="product-content">
            <CardSimple>
                <GenericTable
                    className="table_center"
                    multiSelectable={false}
                    enableSelectAll={false}
                    selectable={false}
                    stripedRows={true}
                    columns={LOOKUP.patient.pointHistory.tableColumns}
                    rows={mapPoints(points.list)}
                />
                <Pagination
                    length={points.total || 0}
                    itemsPerPage={pagination.itemsPerPage}
                    activePage={pagination.activePage}
                    onPageChange={(e) => changePage(e, compName)} />
            </CardSimple>
        </div>
    );
};

export default patientTabPoints;
